(ns app.front.view.group.admin.integration.plan-review
  (:require [app.front.view.group.admin.integration.common :as iconf]
            [app.front.view.group.admin.subs :as gas]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::stored-config
  :<- [::gas/group]
  :-> :group/plan-review-integration-config)

(defn view [{:keys [tr group]}]
  (let [group-id (:db/id group)]
    [iconf/config-editor-page
     (util/mmap {:integration-type           :integration-config.type/plan-review
                 :stored-config-subscription [::stored-config]
                 :save-command               :group/save-plan-review-integration}
                tr group-id)]))
